module.exports = {
  login:{
    zw:'CH',
    mw:'MY',
    en:'ENG',
    name:'Login Name',
    pws:'Password',
    submit:'Login',
    msg:'Fill in the information completely',
    amount:'฿',
    remember:'Remember Password'
  },
  navs:{
    phone:'Phone',
    tel:'Tel',
    betNum:'Bet before withdraw'
  },
  home:{
    maintain:'Under Maintenance',
    login:'Please login First',
    await:'Please Wait',
    customer:'Change password please connect customer service',
    account:'Deposit / Withdraw',
    message:'Message',
    per:'Member Information',
    record:'Game Record',
    paw:"Reset Password",
    exit:'Logout',
    signIn:'Login',
    more:'More',
    hot:'Hot Game',
    live:'LIVE GAME',
    game:'Jackpot',
    new:'New Game',
    slot:'Slot Game',
    fish:'Fish Game',
    rng:'RNG GAME',
    index:'Home',
    app:'Download APP',
    t_1:'Date / Name',
    t_2:'Jackpot Win'

  },
  message:{
    title:'Message',
    per:'Member Info',
    system:'Announcement',
    data:'No message selected',
    close:'CLOSE'
  },
  user:{
    title:'Member Info'
  },
  account:{
    title:'Deposit / Withdraw',
    upper:"Deposit",
    lower:"Withdraw",
    noData:'No More Data',
    sn:'Round Number',
    abbr:'Platform',
    point:'Point',
    rate:'Exchange Rate',
    type:'Type',
    time:'Time',
    homePage:"Home Page",
    lastPage:"Last Page",
    total:'Total',
    info:'Info',
    page:'Page',
    beforeAccount:'Before Deposit',
    afterAccount:'After Deposit',
    amount:'Amount',
  },
  record:{
    title:'Transaction Report',
    no:'Round Number',
    amount:'Bet Amount',
    profit:'Profit',
    time:'Time',
    state:'Status',
    unsettled:'Unsettlement',
    win:'Win',
    lose:'Lose',
    sum:'Draw',
    ping:'Platform',
    operate:'operate',
    submit:'look over',
    submitTitle:'Flow details'
  },
  download:{
    title:'APP download',
    domain:"JY076",
    name:'jy99',
    app:"Download APP",
    num:'4.9',
    score:'5985 scores',
    edition:'# 1',
    style:'Game APP',
    new:'Latest version',
    time:'2022-03-04 1.63(4.7MB)',
    security:'Higher security',
    speed:'Faster opening speed!',
    remember:"No need to remember the URL!"
  },
  loginPaw:{
    title:'Modify login password',
    t_2:'Old password',
    t_3:'New password',
    t_4:'Confirm Password',
    t_5:'Please enter your old password',
    t_6:'Please enter a new password',
    t_7:'Please enter the password again',
    t_8:'confirm',
    t_9:'Modify payment password',
    t_10:'Reset payment password',
    t_11:'Change Password',
    t_12:'Set payment password',
    t_13:'password',
    t_14:'Please input a password',
    t_15:'Please complete the information',
    t_16:'The two passwords are inconsistent',
    t_17:'Password has been modified',
    t_18:'Password set'
  },
  customer:{
    title:'Customer Service',
    tip:'Dear users，If you need to recharge or inquire about website related issues，Please click the official customer service below，We will have a professional customer service team to serve you 24 hours a day',
    copy:'copy',
    qrCode:'QR code',
    close:'closure'
  },
  messenger:{
    title:"24 hours online",
    copy:'Copy account',
    success:'Copy successfully',
    err:'Replication failed',
  },
  Online:{
    title:'online service',
    send:'send',
    drop:'drop down loading',
    face:'QQ emoji',
    tip:'Please select the customer service to contact',
    del:'System has cleared history',
    test:'Please enter the content to send',
  },
  thalIndex:{
    t_1:'Sign in',
    t_2:'WINNERS',
    t_3:'2D/3D',
    t_4:'History',
    t_5:'2D betting',
    t_6:'3D betting',
    t_7:'2D',
    t_8:'3D',
    t_9:'Section',
    t_10:'UPDATED',
    t_11:'Closing Time',
    t_12:'AM',
    t_13:'PM',
    t_14:'Betting',
    t_15:"Internet",
    t_16:'SET:',
    t_17:'VALUE:',
    t_18:'Live',
    t_19:'Modern',
    t_20:'Internet',
    t_21:'Please select a session',
    t_22:"There are currently no sessions available"
  },
  ranking:{
    t_1:'Winners',
  },
  bet2D:{
    t_1:' Betting',
    t_2:'Close Time：',
    t_3:'Luck Number',
    t_4:'Quick number selection',
    t_5:'Note number：',
    t_6:'Total amoun：',
    t_7:'Betting',
    t_8:'Quick selection',
    t_9:'Box',
    t_10:'big',
    t_11:'small',
    t_12:'single',
    t_13:'double',
    t_14:'in twos',
    t_15:'Double single',
    t_16:'Single double',
    t_17:'alone',
    t_18:'the same',
    t_19:'1 whole',
    t_20:'the top',
    t_21:'Later',
    t_22:'Star',
    t_23:'Star R',
    t_24:'Power',
    t_25:'Power R',
    t_26:'20 each'
  },
  bet3D:{
    t_1:' Betting',
    t_2:'number',
    t_3:"Odds",
    t_4:'delete',
    t_5:'amount',
    t_6:'confirmation number',
    t_7:'Please fill in the betting amount',
    t_8:'Successful betting',
    t_9:'Please fill in the correct number format, such as: 000',
    t_10:'The number is currently fully booked',
    t_11:'Please fill in the betting amount for the number',
    t_12:'The lucky number is：',
    t_13:'The number of failed bets is：',
    t_14:'reason',
    t_15:'Please select a number'
  },
  recordsBet:{
    t_1:'Betting record',
    t_2:'Note number',
    t_3:'NO.',
    t_4:'Betting amount',
    t_5:'income',
    t_6:'name',
    t_7:'20231030233000',
    t_8:'number',
    t_9:'amount',
    t_10:'Cashback',
    t_11:'Odds',
    t_12:'date',
    t_13:'Cashback',


  },
  playerRankRecord:{
    t_1:'Order details'
  }


}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js